import { Fragment, useEffect, useState } from 'react';
import ComplaintsAreaChart from './ComplaintsAreaChart';
import React from 'react';

interface ComplaintsGraphProps {
  info: Record<string, number>;
  type: string;
  fetchChartData: (
    type: string,
    date: string,
    setChartData: React.Dispatch<any>,
    setLoading: React.Dispatch<boolean>
  ) => Promise<void>;
}

const ComplaintsGraph = ({ info, type, fetchChartData }: ComplaintsGraphProps) => {
  const years = [
    { label: new Date().getFullYear(), value: 'yearly' },
    { label: new Date().getFullYear() - 1, value: 'yearly1' },
    { label: new Date().getFullYear() - 2, value: 'yearly2' }
  ];

  const [data, setData] = useState<{ name: string; count: number }[]>([]);
  const [totalComplaints, setTotalComplaints] = useState(0);
  const [selectedButton, setSelectedButton] = useState('');
  const [date, setDate] = useState('yearly');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const processComplaintsData = () => {
      try {
        const complaints: any = info;
        const formattedData = Object.keys(complaints?.trend ? complaints?.trend : {}).map(
          (month) => ({
            name: month,
            count: Number(complaints.trend[month])
          })
        );
        setData(formattedData);
        setTotalComplaints(complaints?.total);
      } catch (err: any) {
        console.error(err);
      }
    };
    processComplaintsData();
  }, [info]);

  const handleWeekClick = () => {
    if (date === 'yearly' || date === 'monthly' || date === 'weekly') {
      setDate('weekly');
    }
    setSelectedButton('Week');
    fetchChartData(type, 'weekly', setData, setLoading);
  };

  const handleMonthClick = () => {
    if (date === 'yearly' || date === 'monthly' || date === 'weekly') {
      setDate('monthly');
    }
    setSelectedButton('Month');
    fetchChartData(type, 'monthly', setData, setLoading);
  };

  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedDate = e.target.value;
    setDate(selectedDate);
    setSelectedButton('');
    fetchChartData(type, selectedDate, setData, setLoading);
  };

  return (
    <div className="flex flex-col bg-[#343434] rounded-lg p-2.5 w-full">
      <div className="flex flex-row justify-between items-center">
        <label className="text-xs md:text-base font-normal text-white">{type}</label>
        {totalComplaints > 0 &&
          <Fragment>
            <label className="text-xs md:text-base font-bold text-white">
              {totalComplaints?.toLocaleString()}
            </label>
            <div className="flex justify-between gap-[2px] xl:gap-[10px]">
              <button
                className={`border text-xs md:text-sm px-[5px] md:px-[7px] xl:px-[10px] pt-[1px] pb-[2px] font-normal border-gray-400 rounded-[20px] ${selectedButton === 'Week' ? 'bg-[#006BEA] text-white' : ''
                  } ${date !== 'yearly' && date !== 'weekly' && date !== 'monthly' ? 'bg-gray-400 opacity-50 cursor-not-allowed' : ''}`}
                disabled={date !== 'yearly' && date !== 'weekly' && date !== 'monthly'}
                onClick={handleWeekClick}
              >
                Week
              </button>
              <button
                className={`border text-xs md:text-sm px-[5px] md:px-[7px] xl:px-[10px] pt-[1px] pb-[2px] font-normal border-gray-400 rounded-[20px] ${selectedButton === 'Month' ? 'bg-[#006BEA] text-white' : ''
                  } ${date !== 'yearly' && date !== 'weekly' && date !== 'monthly' ? 'bg-gray-400 opacity-50 cursor-not-allowed' : ''}`}
                disabled={date !== 'yearly' && date !== 'weekly' && date !== 'monthly'}
                onClick={handleMonthClick}
              >
                Month
              </button>
              <select
                name="type"
                className="bg-transparent text-white focus:bg-[#343434] text-xs md:text-sm font-normal border px-[5px] md:px-[7px] xl:px-[10px] pt-[1px] pb-[2px] border-gray-400 rounded-[20px]"
                value={date}
                onChange={handleYearChange}
              >
                {years.map((year) => (
                  <option key={year.value} value={year.value}>
                    {year.label}
                  </option>
                ))}
              </select>
            </div>
          </Fragment>
        }
      </div>
      <div style={{ width: '100%', height: '300px' }}>
        {totalComplaints > 0 ?
          (<ComplaintsAreaChart data={data} />) :
          (<div className='flex justify-center items-center h-full select-none'>
            No records found
          </div>)
        }

      </div>
    </div>
  );
};

export default ComplaintsGraph;
